
<h3 mat-card-subtitle>Errors</h3>
<mat-list role="list">
    <mat-list-item *ngFor="let error of errors" role="listitem">
        <mat-icon class="me-2">error</mat-icon> {{error}}
    </mat-list-item>
</mat-list>
